// extracted by mini-css-extract-plugin
module.exports = {"device-page":"device-page___1K0B3"};